import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function Campanillas() {
  return <NeighborhoodPageContent slug="campanillas" />;
}